module.exports = __webpack_public_path__ + "4326efe16fbe15457352c07c1a3f5de2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/menu/download.svg
// module id = 165
// module chunks = 0